import AsyncCrmSendsByUser from 'framework-asset-preview-lib/internal/objectTypes/0-830/components/CrmSendsByUser/components/AsyncCrmSendsByUser';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
const CUSTOM_PERFORMANCE_SECTION_COMPONENTS = {
  [OBJECT_TYPE.WHATSAPP]: AsyncCrmSendsByUser
};
export function getCustomPerformanceSection(objectTypeId) {
  return CUSTOM_PERFORMANCE_SECTION_COMPONENTS[objectTypeId];
}